import React from "react"

import { NO, YES, NONE, UNLIMITED, VALUE } from "const"
import { LangType } from "client/store"
import { TableColumnEditable } from "client/components"


import { MtPackage } from "server/models"

import TableSelect from "../components/select"
import { styleOffset } from "./index"

const Lifecycle = (lang: LangType) => {
    const columns: TableColumnEditable[] = [
        {
            field: "lifecycleAccess",
            header: lang.lifecycleAccess,
            formatter: (packg: MtPackage) => {
                const { lifecycleModuleAccess } = packg.settingsParsed
                return lang[lifecycleModuleAccess]
            },
            focusedFormatter: (packg: MtPackage) => {
                const { lifecycleModuleAccess } = packg.settingsParsed
                return (
                    <TableSelect
                        text={lang[lifecycleModuleAccess]}
                        label={lang.lifecycleAccess}
                        property={{ lifecycleModuleAccess }}
                        propertyArray={[NO, YES]}
                    />
                )
            },
        },
        {
            field: "lifecycles",
            header: lang.lifecycles,
            style: styleOffset,
            formatter: (packg: MtPackage) => {
                const { lifecycles, lifecyclesValue } = packg.settingsParsed
                if (lifecycles === NONE) return lang.none
                if (lifecycles === VALUE) return lifecyclesValue
                if (lifecycles === UNLIMITED) return lang.unlimited
                return null
            },
            focusedFormatter: (packg: MtPackage) => {
                const { lifecycles, lifecyclesValue } = packg.settingsParsed
                let title = ""
                if (lifecycles === NONE) title = lang.none
                if (lifecycles === VALUE) title = lifecyclesValue.toString()
                if (lifecycles === UNLIMITED) title = lang.unlimited

                return (
                    <TableSelect
                        text={title}
                        label={lang.accountComplianceSets}
                        property={{ lifecycles }}
                        propertyValue={{ lifecyclesValue }}
                        propertyArray={[NONE, VALUE, UNLIMITED]}
                    />
                )
            },
        },
        {
            field: "subLifecycles",
            header: lang.subLifecycles,
            style: styleOffset,
            formatter: (packg: MtPackage) => {
                const { subLifecycles, subLifecyclesValue } = packg.settingsParsed
                if (subLifecycles === NONE) return lang.none
                if (subLifecycles === VALUE) return subLifecyclesValue
                if (subLifecycles === UNLIMITED) return lang.unlimited
                return null
            },
            focusedFormatter: (packg: MtPackage) => {
                const { subLifecycles, subLifecyclesValue } = packg.settingsParsed
                let title = ""
                if (subLifecycles === NONE) title = lang.none
                if (subLifecycles === VALUE) title = subLifecyclesValue.toString()
                if (subLifecycles === UNLIMITED) title = lang.unlimited

                return (
                    <TableSelect
                        text={title}
                        label={lang.subLifecycles}
                        property={{ subLifecycles }}
                        propertyValue={{ subLifecyclesValue }}
                        propertyArray={[NONE, VALUE, UNLIMITED]}
                    />
                )
            },
        },
    ]

    return columns
}
export default Lifecycle
